import React, { useEffect, useState } from "react";
import { FaFileExcel, FaSearch } from "react-icons/fa";
import { Form, InputGroup, Button, Badge, DropdownButton, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Table from "../../constants/Table";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

const VendorOrders = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Statuses");
      const navigate = useNavigate();
  const [rfq, setRFQ] = useState([]);
  const [loading, setLoading] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const statusBadge = (status) => {
    switch (status) {
      case "Requested":
        return <Badge bg="primary" pill>Requested</Badge>;
      case "Draft":
        return <Badge bg="secondary" pill>Draft</Badge>;
      case "Completed":
        return <Badge bg="success" pill>Completed</Badge>;
      default:
        return <Badge bg="light" text="dark">{status}</Badge>;
    }
  };

  const actionButton = () => (
    <Button variant="outline-danger" size="sm">View</Button>
  );


  const getRFQList = async () => {
    setLoading(true);
    try {
      let res = await apicall.get(`orders/${userDetails?.id}`);
      setRFQ(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };
   useEffect(() => {
      getRFQList();
    }, []);
  const rfq_Data = rfq.map(item => {
  const statusColors = {
    5: "gray",       
    8: "orange",     
    3: "green",     
    4: "red",      
    10: "blue", 
    6: "green",
  };

  const color = statusColors[item.status] || "gray";

  return [
          `O-2025-${item.order_id}`,
 `RFQ-2025-${item.rfq_id}`,
    item.title,
    [...new Set(item.products?.map(p => p.company))].join(", "),
    new Date(item.responsible_date).toLocaleDateString(),
    new Date(item.delivery_date).toLocaleDateString(),
    item?.total_price,
    <span
      style={{
        color: color,
        fontWeight: "bold",
        borderRadius: "20px",
        padding: "4px 10px",
        textTransform: "capitalize",
      }}
    >
      {item.status_name || "N/A"}
    </span>,
  ];
});

    const bookingHeaders = [
        'Order Id',
        'RFQ Reference',
        'Title',
        'Order Date',
        'Delivery Date',
        'Amount',
        'Status',
    ];
      const handleDetails = (index) =>{
        const selectedId = rfq[index];
navigate(`/vendor_order_details/${selectedId.id_rfq}`, {
            
    state: { orders: selectedId },
  
        });
    }
    const handleExport = () => {

      const exportData = rfq_Data.map((item) => ({
        "Order Id": item.display_order_id,
        "RFQ Reference": item.display_id,
        "Title": item.title,
        "Order Date": new Date(item.created).toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        }),
        "Delivery Date": new Date(item.delivery_date).toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        }),
        "Amount": item.total_price,
        "Status": item.status_name,
      }));
    
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
    
      XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
    
      XLSX.writeFile(workbook, "Orders_List.xlsx");
    };
return (
  <div className="rfq-section">
    <div className="rfq-header">
      <h2>Orders</h2>
    </div>

<div className="d-flex justify-content-between align-items-center mb-3 mx-5">
  {/* Left side: Search + Dropdown */}
  <div className="d-flex align-items-center gap-3">

    <InputGroup style={{ width: "300px" }}>
      <Form.Control
        type="search"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    
    </InputGroup>

    {/* Dropdown */}
    <div style={{ minWidth: "400px" }}>
      <DropdownButton
        id="status-filter"
        variant="outline-secondary"
        title="All Statuses"
        className="w-100"
      >
        <Dropdown.Item key="all-status">All Statuses</Dropdown.Item>
        <Dropdown.Item key="pending">Pending</Dropdown.Item>
        <Dropdown.Item key="approved">Approved</Dropdown.Item>
        <Dropdown.Item key="rejected">Rejected</Dropdown.Item>
      </DropdownButton>
    </div>
  </div>

  {/* Right side: Export button */}
  <button className="btn btn" onClick={handleExport}>Export</button>
</div>
  <Table
                      headers={bookingHeaders}
                      data={rfq_Data}
                      pagination={true}
                      recordsCount={10}
                      Action={handleDetails}

                      // details={handleDetails}
                      // detailsAtStart={true}
                  />
  </div>
);

};

export default VendorOrders;
